"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import { Popover } from '../Popover/Popover.mjs';
import styles from './ContextualHelp.module.scss.mjs';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import 'mobx';
import { useOverlayController } from '../../lib/controller/overlay/useOverlayController.mjs';

const ContextualHelp = flowComponent("ContextualHelp", (props) => {
  const {
    children,
    controller: controllerFromProps,
    ref: ignoredRef,
    ...rest
  } = props;
  const controllerFromContext = useOverlayController("ContextualHelp", {
    reuseControllerFromContext: true
  });
  const controller = controllerFromProps ?? controllerFromContext;
  const propsContext = {
    Heading: {
      level: 5
    }
  };
  return /* @__PURE__ */ jsx(Popover, { withTip: true, ...rest, controller, children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsx("div", { className: styles.contextualHelp, children }) }) });
});

export { ContextualHelp, ContextualHelp as default };
//# sourceMappingURL=ContextualHelp.mjs.map
